<div class="feedback-modal">
  <div class="feedback-modal_header">
    <p class="feedback-modal_header__title">Give additional feedback</p>
    <stxt-svg-icon
      [iconConfig]="closeSvg"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"
      tabindex="0"
      class="feedback-modal_header__close"
    ></stxt-svg-icon>
  </div>
  <div class="feedback-modal_body">
    <div class="feedback-modal_body__top">
      <stxt-svg-icon
        [iconConfig]="feedbackTypeSvg"
        [class.regenerate]="feedbackType === EFeedbackType.Regenerate"
        class="feedback-icon"
      ></stxt-svg-icon>
      <p>{{ feedbackTitle }}</p>
      <span *ngIf="feedbackType === EFeedbackType.Regenerate">
        Let us know what didn't work first.
      </span>
    </div>
    <div class="feedback-modal_body__mid">
      <button
        *ngFor="let option of getCurrentFeedbackOptions()"
        [class.selected]="isOptionSelected(option)"
        (click)="selectOption(option)"
        class="feedback-button btn-nostyle"
      >
        {{ option }}
      </button>
    </div>
    <div class="feedback-modal_body__bottom">
      <form class="w-full" [formGroup]="feedbackInputForm">
        <stxt-input formControlName="feedback" [inputConfig]="feedbackInput"></stxt-input>
      </form>
    </div>
    <!-- TODO: Add hint for feedback when we will have report page -->
    <!-- <div class="feedback-modal_body__hint">
      <p>{{ hintConfiguration.textLeft }}</p>
      <stxt-svg-icon [iconConfig]="hintConfiguration.svg" class="hint-icon"></stxt-svg-icon>
      <span (click)="switchFeedbackType()" (keydown.enter)="switchFeedbackType()" tabindex="0">
        {{ hintConfiguration.textRight }}
      </span>
    </div> -->
  </div>
  <div class="feedback-modal_footer">
    <stxt-button
      [buttonConfig]="cancelButton"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"
      tabindex="0"
    >
      {{ cancelButton.text }}
    </stxt-button>
    <stxt-button
      [buttonConfig]="submitButton"
      [disabled]="selectedOptions.length === 0 && !feedbackInputForm.get('feedback')?.value"
      (click)="submitFeedback()"
      (keydown.enter)="submitFeedback()"
      tabindex="0"
    >
      {{ submitButton.text }}
    </stxt-button>
  </div>
</div>
